import { decode } from 'js-base64';
import { NotificationCard } from '../components/Card';
import { Avatar, Box, Flex, Icon, Text } from '@chakra-ui/react';
import { NotificationTime } from '../components/Time';
import { NotificationLink } from '../components/NotificationLink';
import OutreachSender from '@/assets/icons/notification/OutreachSender';

const ProjectInvitationWrapper = ({
  notification = () => {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const { project_name, sender_name, project_url } = data;
  const parts = project_url.split('/');
  const projectId = parts[parts.length - 1];

  return (
    <Flex>
      <Box>
        <Box height="40px" pos="relative">
          <Avatar
            width="36px"
            height="36px"
            borderRadius="8px"
            className="avatar-md"
            name={sender_name}
          />
          <Box pos="absolute" bottom="-24px" left="9px">
            <Icon as={OutreachSender} width="40px" height="40px" />
          </Box>
        </Box>
      </Box>
      <Box ml="12px">
        <Flex pr="12px">
          <Text>
            <Text as="span" fontWeight="semiBold" pr="4px">
              {sender_name}
            </Text>
            has added you to the project
            <NotificationLink
              to={`/projects/${projectId}`}
              label={project_name}
              onClose={onClose}
              notification={notification}
              data-test-id="project-link"
            />
          </Text>
        </Flex>
        <NotificationTime notification={notification} />
      </Box>
    </Flex>
  );
};

export const ProjectInvitation = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ProjectInvitationWrapper notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
